import { useEffect, useState } from "react";

const NAV = [
  { id: "story", label: "Story" },
  { id: "shop", label: "Shop" },
  { id: "connect", label: "Work With Me" },
];

export default function SiteHeader({ onNav }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`} data-testid="site-header">
      <button
        className="hdr-brand"
        onClick={() => onNav("hero")}
        data-testid="header-brand"
        aria-label="Emmy by Design — home"
      >
        <span className="nm">Emmy</span>
        <span className="sb">by design</span>
      </button>

      <nav className="hdr-nav">
        {NAV.map((n) => (
          <button
            key={n.id}
            className="hdr-link"
            data-testid={`nav-${n.id}`}
            onClick={() => onNav(n.id)}
          >
            {n.label}
          </button>
        ))}
        <button className="hdr-cta" data-testid="nav-letter" onClick={() => onNav("letter")}>
          The Thursday Edit
        </button>
      </nav>
    </header>
  );
}
